import { createContext } from "react";

export const TableFooterContext = createContext<any>(undefined);

export default TableFooterContext;
